<section class="tst-stack" aria-label="Avisos">
  @for (toast of toastService.toasts(); track toast.id) {
  <div class="tst" [attr.data-type]="toast.type" [class.tst--leaving]="toast.leaving"
    [attr.role]="toast.type === 'error' || toast.type === 'warning' ? 'alert' : 'status'"
    (mouseenter)="toastService.pause(toast.id)" (mouseleave)="toastService.resume(toast.id)"
    (focusin)="toastService.pause(toast.id)" (focusout)="toastService.resume(toast.id)">
    <span class="tst__icon" aria-hidden="true">
      @switch (toast.type) {
        @case ('success') {
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
          stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
        }
        @case ('error') {
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
          stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12" /></svg>
        }
        @case ('warning') {
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
          stroke-linecap="round" stroke-linejoin="round"><path d="M12 8v5M12 17h.01" /></svg>
        }
        @default {
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
          stroke-linecap="round" stroke-linejoin="round"><path d="M12 11v6M12 7h.01" /></svg>
        }
      }
    </span>
    <p class="tst__msg">
      <span class="tst__sr">{{ kindLabel[toast.type] }}: </span>
      <span [innerHTML]="toast.message"></span>
    </p>
    <button type="button" class="tst__close" (click)="toastService.remove(toast.id)" aria-label="Cerrar aviso">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12" /></svg>
    </button>
    <!-- Time left; restarts when the same toast shows again, pauses on hover -->
    @if (!toast.leaving) {
    @for (v of [toast.version]; track v) {
    <span class="tst__timer" [style.animation-duration.ms]="toast.duration" aria-hidden="true"></span>
    }
    }
  </div>
  }
</section>
